import { api, ReactQueryOptions, RouterInputs } from '@api'

type inputType = RouterInputs['SubscriptionManager']['getSingleSubscription']
type queryOptionsType = ReactQueryOptions['SubscriptionManager']['getSingleSubscription']

export const useGetSingleSubscription = (input: inputType, options?: queryOptionsType) => {
    return api.SubscriptionManager.getSingleSubscription.useQuery(input, {
        ...options,
        queryKey: ['SubscriptionManager.getSingleSubscription', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
}
